import { Injectable } from '@angular/core';

const REDIRECT_URL_KEY = 'redirectUrl';

/**
 * Centralizes the "return to originally requested URL after login" behavior
 * used by AuthGuard and the login components.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  isAuthenticated(): boolean {
    return !!(localStorage.getItem('token') && localStorage.getItem('account'));
  }

  setRedirectUrl(url: string): void {
    sessionStorage.setItem(REDIRECT_URL_KEY, url);
  }

  consumeRedirectUrl(): string | null {
    const url = sessionStorage.getItem(REDIRECT_URL_KEY);
    this.clearRedirectUrl();
    return url;
  }

  clearRedirectUrl(): void {
    sessionStorage.removeItem(REDIRECT_URL_KEY);
  }
}